import { CreatorSupportChannelsApiClient } from '@fourthwall/services/dist/CreatorSupportApiClient/CreatorSupportApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useCreatorSupportChannelsQuery = createQueryHook(
  CreatorSupportChannelsApiClient.getCreatorSupportChannels,
  {
    queryKey: ['getCreatorSupportChannels'],
  },
)
